import React from "react"

export default function Linkedin() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M7.02178 27.5781H1.41515V10.7582H7.02178V27.5781ZM4.21847 7.5811C2.34959 7.5811 0.854492 6.086 0.854492 4.21712C0.854492 2.34825 2.34959 0.853149 4.21847 0.853149C6.08734 0.853149 7.58244 2.34825 7.58244 4.21712C7.58244 6.086 6.08734 7.5811 4.21847 7.5811ZM27.5794 27.5781H21.9728V17.673C21.9728 16.178 20.6646 14.8697 19.1695 14.8697C17.6744 14.8697 16.3661 16.178 16.3661 17.673V27.5781H10.7595V10.7582H16.3661V13.0008C17.3006 11.5057 19.3563 10.3844 21.0383 10.3844C24.5892 10.3844 27.5794 13.3746 27.5794 16.9255V27.5781Z"
          fill="#3870DE"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="27.9975" height="27.9975" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
